import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import chairmanImg from "../assets/chairman.jpeg";
import API_BASE_URL from "../config/api";

const images = require
  .context("../assets/gallery", false, /\.(png|jpe?g|svg)$/)
  .keys()
  .map(
    require.context("../assets/gallery", false, /\.(png|jpe?g|svg)$/)
  );

function Home() {
  // const [images, setImages] = useState([]);
  const sliderRef = useRef(null);

  // useEffect(() => {
  //   axios
  //     .get(`${API_BASE_URL}/gallery/files`)
  //     .then((res) => setImages(res.data))
  //     .catch((err) => console.error(err));
  // }, []);

  return (
    <div className="page home-bg">

      {/* ================= WELCOME CARD ================= */}
      <section className="welcome-section">
        <div className="welcome-card">
          <h1 className="welcome-title">
            Welcome to Blue Moon Degree College
          </h1>

          <p>
            Blue Moon Degree College is a centre of academic excellence committed to
            quality education and disciplined learning. Our institution focuses on
            nurturing intellectual growth, ethical values, and professional
            competence among students.
          </p>

          <p>
            We provide a supportive learning environment that encourages innovation,
            leadership, and holistic development. At Blue Moon Degree College, we
            prepare students to face future challenges with confidence and
            responsibility.
          </p>
        </div>
      </section>

      {/* ================= CHAIRMAN MESSAGE ================= */}
      <section className="chairman-section">
        <div className="chairman-card">
          <div className="chairman-image">
            <img src={chairmanImg} alt="Chairman" />
          </div>

          <div className="chairman-content">
            <h2>Chairman’s Message</h2>

            <p className="chairman-quote">
              “It is my privilege to lead an institution dedicated to academic
              excellence, disciplined learning, and holistic student
              development. Our college remains committed to providing a
              professional learning environment supported by qualified
              faculty, strong infrastructure, and values-based education.”
            </p>

            <p className="chairman-quote">
              “I extend my sincere gratitude to all stakeholders for their
              continued trust. I welcome all aspiring students to join our
              institution and pursue a future shaped by knowledge, integrity,
              and excellence.”
            </p>

            <h4 className="chairman-name">Sri M. Siva Sankar</h4>
            <span className="chairman-role">
              Chairman, Blue Moon Degree College
            </span>
          </div>
        </div>
      </section>

      {/* ================= PRINCIPAL MESSAGE ================= */}
      <section className="principal-section">
        <div className="principal-card">
          <div className="principal-content">
            <h2>Principal’s Message</h2>

            <p className="principal-quote">
              “Our degree college is a place where dreams are shaped, talents are
              discovered, and leaders are created. We believe every student carries
              unlimited potential, and it is our mission to guide them towards
              excellence with knowledge, values, and confidence.”
            </p>

            <p className="principal-quote">
              “Together, we strive to build a future where our students rise as
              responsible citizens, compassionate humans, and achievers in every
              field.”
            </p>

            <h4 className="principal-name">R. Venkata Reddy</h4>
            <span className="principal-role">
              Principal, Blue Moon Degree College
            </span>
          </div>
        </div>
      </section>

      {/* ================= VISION & MISSION ================= */}
      <section className="vision-mission-section">
        <div className="vm-container">
          <div className="vm-card vision">
            <div className="vm-icon">🎯</div>
            <h2>Our Vision</h2>
            <p>
              To emerge as a centre of academic excellence that empowers students
              with knowledge, skills, and values to meet global challenges.
            </p>
            <p>
              We envision nurturing responsible citizens, innovative thinkers,
              and ethical leaders who contribute meaningfully to society.
            </p>
            <p>
              Our goal is to create a vibrant learning environment that inspires
              lifelong learning and personal growth.
            </p>
          </div>

          <div className="vm-card mission">
            <div className="vm-icon">🚀</div>
            <h2>Our Mission</h2>
            <p>
              To provide quality education through experienced faculty,
              modern infrastructure, and student-centric teaching methods.
            </p>
            <p>
              To promote academic discipline, innovation, and research-oriented
              learning across all programmes.
            </p>
            <p>
              To instil moral values, leadership qualities, and social
              responsibility in every student.
            </p>
          </div>
        </div>
      </section>

      {/* ================= COURSES OFFERED ================= */}
      <section className="courses-section">
        <div className="courses-header">
          <h2>Courses We Offer</h2>
          <p>
            We offer industry-relevant undergraduate programs designed to build
            strong academic foundations and career-ready skills.
          </p>
        </div>

        <div className="courses-grid">
          <div className="course-card">
            <span className="course-icon">💻</span>
            <h3>B.Sc Honours Computer Science</h3>
            <p>Advanced computing concepts and modern technologies.</p>
          </div>

          <div className="course-card">
            <span className="course-icon">🌿</span>
            <h3>B.Sc Honours Botany</h3>
            <p>Plant sciences with practical ecological exposure.</p>
          </div>

          <div className="course-card">
            <span className="course-icon">📐</span>
            <h3>B.Sc Honours Mathematics</h3>
            <p>Analytical and problem-solving skills development.</p>
          </div>

          <div className="course-card">
            <span className="course-icon">🧬</span>
            <h3>B.Sc Honours Zoology</h3>
            <p>In-depth animal biology and life sciences.</p>
          </div>

          <div className="course-card">
            <span className="course-icon">💼</span>
            <h3>B.Com Honours Computer Applications</h3>
            <p>Commerce integrated with business technology.</p>
          </div>

          {/* <div className="course-card">
            <span className="course-icon">📊</span>
            <h3>B.Com Honours Accounting</h3>
            <p>Accounting, finance, and taxation fundamentals.</p>
          </div> */}

          <div className="course-card">
            <span className="course-icon">🏢</span>
            <h3>BBA (Bachelor of Business Administration)</h3>
            <p>Management, leadership, and business strategy skills.</p>
          </div>

          <div className="course-card">
            <span className="course-icon">🖥️</span>
            <h3>BCA (Bachelor of Computer Applications)</h3>
            <p>Software development, programming, and IT fundamentals.</p>
          </div>
        </div>
      </section>

      {/* ================= CAMPUS GALLERY ================= */}
      {images.length > 0 && (
        <section className="campus-gallery-section">
          <div className="campus-header">
            <h2>Campus Gallery</h2>
            <p>Experience our vibrant campus life and infrastructure</p>
          </div>

          <div className="campus-slider-wrapper">

            <button
              className="campus-nav left"
              onClick={() =>
                sliderRef.current.scrollBy({
                  left: -420,
                  behavior: "smooth",
                })
              }
            >
              ‹
            </button>

            <div className="campus-slider" ref={sliderRef}>
              {images.map((img, index) => (
                <div className="campus-slide" key={index}>
                  <img
                    src={img}
                    alt={`Campus ${index}`}
                  />
                </div>
              ))}
            </div>

            <button
              className="campus-nav right"
              onClick={() =>
                sliderRef.current.scrollBy({
                  left: 420,
                  behavior: "smooth",
                })
              }
            >
              ›
            </button>

          </div>
        </section>
      )}

    </div>
  );
}

export default Home;

